import { __awaiter, __generator } from "tslib";
import Vue from 'vue';
import Http from 'axios';
import Builder from '@app/store/builder';
import Navigation from '@app/store/modules/navigation';
import Router from '@app/router';
import RouterFunctions from '@app/router/functions';
/**
 * Enable/disable debug info in the browser developer console
 */
export var DEBUG_MODE = false;
/**
 * Store root state and type definitions
 */
var STATE = Builder.state({
    pageLoading: window.SSR ? false : true,
    pageData: {},
    locale: null,
    languages: window.LANGUAGES || [],
    routesLoaded: null,
});
/**
 * Store state getters
 */
var GETTERS = {
    activeLanguage: function () {
        return STATE.languages.find(function (language) { return language.is_current == true; }) || null;
    }
};
/**
 * Store state mutations
 */
var MUTATIONS = {
    setLocale: function (locale) {
        STATE.locale = locale;
    },
    setLoading: function (loading) {
        STATE.pageLoading = loading;
    },
    setPageData: function (path, data) {
        Vue.set(STATE.pageData, path, data);
    },
    setRoutesLoadedPromise: function (promise) {
        STATE.routesLoaded = promise;
    }
};
/**
 * Store actions
 */
var ACTIONS = {
    loadRoutesData: function () {
        return __awaiter(this, void 0, void 0, function () {
            var api, response, routes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = Http.get('/api/routes');
                        MUTATIONS.setRoutesLoadedPromise(new Promise(function (resolve) {
                            api.then(function () { return resolve(); });
                        }));
                        return [4 /*yield*/, api];
                    case 1:
                        response = _a.sent();
                        routes = response.data.map(function (uri) {
                            var route = RouterFunctions.makeRoute(uri);
                            // Write eager loaded route data to store
                            if (uri.uriable && uri.uriable.parent) {
                                MUTATIONS.setPageData(route.path, uri.uriable.parent);
                            }
                            return route;
                        }).filter(function (route) {
                            // Filter out already existing routes
                            return !RouterFunctions.routeExists(route.path);
                        });
                        Router.addRoutes(routes);
                        RouterFunctions.addFinalRoutes();
                        return [2 /*return*/, response];
                }
            });
        });
    },
    loadPageData: function (path) {
        return Http.get("/api" + path).then(function (res) {
            MUTATIONS.setPageData(path, res.data);
        }).catch(function (ex) {
            if (ex.response.status === 301 || ex.response.status === 302) {
                MUTATIONS.setPageData(path, ex.response.data);
            }
        });
    }
};
var Store = Vue.observable({
    STATE: STATE,
    GETTERS: GETTERS,
    MUTATIONS: MUTATIONS,
    ACTIONS: ACTIONS,
    Navigation: Navigation,
    registerModule: function (name, module) {
        Vue.set(this, name, module);
    }
});
export default Store;
